import moment from "moment";
import { ModelBase } from "../abstract/model-base.model";
import { CustomProfile } from "../authorization/custom-profile.model";


export class UserCustomProfile extends ModelBase {

    static override CLASS_NAME: string = 'UserCustomProfile';

    private _dateFrom!: moment.Moment;
    private _dateTo!: moment.Moment;
    private _profile!: CustomProfile;
    private _profileLabel!: string;

    public get dateFrom(): moment.Moment {
        return this._dateFrom;
    }

    public set dateFrom(value: any) {
        this._setValue('_dateFrom', value, 'date');
    }

    public get dateTo(): moment.Moment {
        return this._dateTo;
    }

    public set dateTo(value: any) {
        this._setValue('_dateTo', value, 'date');
    }

    public get profile(): CustomProfile {
        return this._profile;
    }

    public set profile(value: any) {
        this._setValue('_profile', value, 'CustomProfile');
    }

    public get profileLabel(): string {
        return this._profileLabel;
    }

    public set profileLabel(value: string) {
        this._setValue('_profileLabel', value, 'string');
    }
}